<template>
  <div>
    <div ref="joinMeetorDetailBox" class="joinMeetorDetailBox">
      <!-- 返回 -->
      <!-- <div class="returnButton" @click="returnButton">
        <i class="el-icon-arrow-left"></i>
        返回
      </div> -->
      <div class="desc" v-loading="isDetailDataLoading">
        <div class="left">
          <img
            src=" https://baike-med-1256891581.file.myqcloud.com/2021043/416199b0-9d97-11eb-87f5-87f8260230cc_0.png"
            alt=""
          />
          <p>{{ detailData.length ? detailData[0].meeting_name : '--' }}</p>
          <p>
            {{
              detailData.length
                ? dateFormat(new Date(detailData[0].start_time * 1000), 'YYYY-MM-dd HH:mm:SS')
                : '--'
            }}
          </p>
        </div>
        <el-table :data="detailData">
          <el-table-column prop="applier_name" label="会议申请人"></el-table-column>
          <el-table-column prop="applier_id" label="申请人员工号"></el-table-column>
          <el-table-column prop="state" label="会议是否完成">
            <template slot-scope="scope">{{ !!scope.row.state ? '是' : '否' }}</template>
          </el-table-column>
          <el-table-column prop="is_violate" label="是否合规">
            <template slot-scope="scope">{{ !!scope.row.is_violate ? '否' : '是' }}</template>
          </el-table-column>
          <el-table-column prop="duration" label="会议时长">
            <template slot-scope="scope">{{ formatMinsToHour(scope.row.duration) }}</template>
          </el-table-column>
          <el-table-column prop="product_name" label="相关产品">
            <template slot-scope="scope">{{ scope.row.product_name.join(',') }}</template>
          </el-table-column>
          <el-table-column prop="type" label="会议类型">
            <template slot-scope="scope">{{ renderMeetingTypeName(scope.row.type) }}</template>
          </el-table-column>
          <el-table-column prop="hospital_name" label="会议医院">
            <template slot-scope="scope">
              <el-button
                type="text"
                class="cell"
                style="color: #409eff"
                @click="clickToHospitalDetail(scope.row)"
              >
                {{ scope.row.hospital_name }}
              </el-button>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="备注"></el-table-column>
        </el-table>
      </div>
      <div class="content-wrap" v-loading="tableLoading">
        <div class="filter-content">
          <el-form inline>
            <el-form-item label="医生姓名:">
              <el-input v-model="doctorName" clearable placeholder="请输入" />
            </el-form-item>
          </el-form>
          <div class="button-group">
            <el-button type="primary" @click="clickToFilter">筛选</el-button>
            <ExportExcel
              :config-name="$options.name"
              :excel-data="excelData"
              :is-loading="isExportLoading"
              @emit="handleExportExcel"
            ></ExportExcel>
          </div>
        </div>
        <!-- 表格 -->
        <div class="meeting-table-wrap">
          <el-table class="my-table" :data="tableData">
            <template slot="empty">
              <NoData></NoData>
            </template>
            <el-table-column prop="doctor_name" label="参会人姓名">
              <template slot-scope="scope">
                <span>{{ scope.row.doctor_name }}</span>
                <el-tag
                  v-if="scope.row.is_snap"
                  effect="plain"
                  size="mini"
                  style="margin-left: 10px"
                >
                  临时
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="hospital_name" label="所在医院"></el-table-column>
            <el-table-column prop="department_name" label="科室" />
            <el-table-column prop="doctor_level" label="等级" />
            <el-table-column prop="speaker_status" width="" label="是否讲者">
              <template slot-scope="scope">{{ !!scope.row.speaker_status ? '是' : '否' }}</template>
            </el-table-column>
            <el-table-column prop="duration" label="参会时长(min)" width="120">
              <template slot-scope="scope">
                {{ formatMinsToHour(scope.row.duration) }}
              </template>
            </el-table-column>
            <el-table-column prop="attend_num" label="30天内参会次数" />

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click.native.prevent="clickToDoctorDetail(scope.row)">
                  查看详情
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            class="pagination"
            style="background-color: #ffffff"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="g_pageSizesConfig"
            :total="total"
            :page-size="pagination.page_size"
            :current-page="pagination.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMeetingAttendantListApi, getMeetingDetailApi } from '@/api/dataCenter';
import { formatMinsToHour } from '@/utils/util';
import { dateFormat, getMinuteNumber } from '@/utils/time.js';
import NoData from '@/components/no-data';
import ExportExcel from '@/components/export-excel';
export default {
  name: 'MeetingAttendantList',
  components: {
    NoData,
    ExportExcel,
  },
  data() {
    return {
      meetingId: null,
      dateFormat,
      getMinuteNumber,
      formatMinsToHour,
      detailData: [],
      isDetailDataLoading: false,
      doctorName: '',
      tableData: [],
      total: 0,
      pagination: {
        page_size: this.g_pageSizeDefault,
        page_index: 1,
      },
      tableLoading: false,
      excelData: [],
      isExportLoading: false,
    };
  },
  computed: {
    meetingTypeOptions() {
      return this.$store.state.meetingData.meetingTypeOptions;
    },
  },
  created() {
    this.$store.commit('user/setBreadcrumb', [
      {
        menu_name: '数据中心',
      },
      {
        menu_name: '会议数据',
        menu_path: 'meetingData',
      },
      {
        menu_name: '会议详情',
        menu_path: 'meetingDataDetail',
        menu_params: { date: this.$route.query.date },
      },
      {
        menu_name: '参会者详情',
        menu_path: '',
      },
    ]);
    this.pagination.page_size = this.g_pageSizeDefault;
    this.meetingId = this.$route.query.meetingId;
    this.$store.dispatch('meetingData/getMeetingTypeList');
    this.getMettingDetail();
    this.getTableList();
  },
  methods: {
    returnButton() {
      this.$router.go(-1);
    },
    // 获取会议详情
    async getMettingDetail() {
      this.isDetailDataLoading = true;
      try {
        const res = await getMeetingDetailApi({
          meeting_id: this.meetingId,
        });
        res.end_time = res.start_time + res.duration;
        this.detailData = [res];
      } catch {
        this.$Message('网络错误, 请稍后再试');
        this.detailData = [];
      }
      this.isDetailDataLoading = false;
    },
    // 获取会议类型名称
    renderMeetingTypeName(value) {
      const index = this.meetingTypeOptions.findIndex((i) => i.value === value);
      if (index !== -1) {
        return this.meetingTypeOptions[index].label;
      }
      return '--';
    },
    handleCurrentChange(val) {
      this.pagination.page_index = val;
      this.getTableList();
    },
    handleSizeChange(size) {
      this.pagination.page_size = size;
      this.getTableList();
    },
    async getTableList() {
      this.tableLoading = true;
      const params = {
        meeting_id: this.meetingId,
        // meeting_id: '1',
        doctor_name: this.doctorName,
        ...this.pagination,
      };
      try {
        const res = await getMeetingAttendantListApi(params);
        this.tableData = res.data;
        this.total = res.total_num;
      } catch (err) {
        console.log('error', err);
        this.tableData = [];
        this.total = 0;
        this.$message.error(`查询参会人列表失败 ${err.message || ''}`);
      }
      this.tableLoading = false;
    },
    async handleExportExcel() {
      this.isExportLoading = true;
      const params = {
        meeting_id: this.meetingId,
        doctor_name: this.doctorName,
        page_index: 1,
        page_size: 9999,
      };
      try {
        const res = await getMeetingAttendantListApi(params);
        this.excelData = res.data.map((item) => {
          const items = { ...item };
          items.speaker_status = !!item.speaker_status ? '是' : '否';
          items.duration = this.formatMinsToHour(item.duration);
          if (item.is_snap) {
            items.doctor_name += '(临时)';
          }
          return items;
        });
      } catch (err) {
        console.log('error', err);
        this.excelData = [];
      }
      this.isExportLoading = false;
    },
    clickToFilter() {
      this.pagination.page_index = 1;
      this.getTableList();
    },
    clickToDoctorDetail(row) {
      this.g_tourl(`/saas/doctorInfo.html?doctor_id=${row.doctor_id}`, {
        open: true,
      });
    },
    clickToHospitalDetail(row) {
      if (!row.hospital_id) {
        this.$message('暂无讲者或讲者暂无医院，请查证!');
        return;
      }
      this.g_tourl(`/saas/setUp/hospitalManagement/hospitalDetail.html?id=${row.hospital_id}`, {
        open: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.joinMeetorDetailBox {
  background: #f7f9fc;
  /* 返回 */
  .returnButton {
    background-color: #fff;
    padding-bottom: 20px;
    cursor: pointer;
  }
  /* 参会信息 */
  .desc {
    font-size: 16px;
    color: #606266;
    margin: 24px 0 30px 0;
    display: flex;
    background-color: #fff;
    .left {
      height: 152px;
      text-align: center;
      width: 200px;
      border-right: 1px solid #ebeef5;
      > img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-top: 16px;
      }
      > p {
        margin-top: 12px;
        font-size: 14px;
        color: #313233;
      }
    }
    .clickDeputyInfo {
      outline-style: none;
      border: 0;
      background-color: transparent;
      font-size: 16px;
      color: #0081cc;
      line-height: 16px;
    }
  }
  .content-wrap {
    background-color: #fff;
    margin-top: 24px;
    .filter-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      height: 68px;
      .el-form-item {
        margin-bottom: 0;
      }
    }
    .pagination {
      float: right;
      margin-top: 12px;
    }
  }
}
</style>
